
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/verify-email",
      function () {
        return require("private-next-pages/verify-email/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/verify-email"])
      });
    }
  